module.exports = __webpack_public_path__ + "img/hr-concrete-u-mask.6f3b03fb.png";